<template>
  <div class="growthFileShengya">
     <div class="rgtx">
       <h3><span>偏好程度</span></h3>
       <div class="grade">
         <p>强</p>
         <p>明显</p>
         <p>中等</p>
         <p>轻微</p>
         <p>中等</p>
         <p>明显</p>
         <p>强</p>
       </div>
       <div class="middle">
         <ul class="left">
           <li :class="(waixiang-neixiang)>0?'active':''">外向（E）</li>
           <li :class="(shigan-zhijue)>0?'active':''">实感（S）</li>
           <li :class="(sikao-qinggan)>0?'active':''">思考（T）</li>
           <li :class="(panduan-zhijueb)>0?'active':''">判断（J）</li>
         </ul>
         <div class="center">
           <ul class="centerLeft">
             <li>
               <div class="con_px" :style="{width:(waixiang-neixiang)/70*155+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(shigan-zhijue)/70*155+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(sikao-qinggan)/70*155+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(panduan-zhijueb)/70*155+'px'}"></div>
             </li>
           </ul>
           <ul class="centerRight">
             <li>
               <div class="con_px" :style="{width:(neixiang-waixiang)/70*155+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(zhijue-shigan)/70*155+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(qinggan-sikao)/70*155+'px'}"></div>
             </li>
             <li>
               <div class="con_px" :style="{width:(zhijueb-panduan)/70*155+'px'}"></div>
             </li>
           </ul>
         </div>
         <ul class="left" style="float: right">
           <li :class="(waixiang-neixiang)<0?'active':''">（I）内向</li>
           <li :class="(shigan-zhijue)<0?'active':''">（N）直觉</li>
           <li :class="(sikao-qinggan)<0?'active':''">（F）情感）</li>
           <li :class="(panduan-zhijueb)<0?'active':''">（P）知觉</li>
         </ul>
       </div>
       <div class="conclusion">
         <p>你的人格类型为</p>
         <p class="name name1">{{name}}</p>
         <p class="name name2">{{desc&&desc.replace(/[\s|\S]*(（[\s|\S]*）)[\s|\S]*/g,'$1')}}</p>
           <p style="font-size: 20px;font-weight: bold">
           人格特性评估结果示意图
           </p>
       </div>
     </div>
  </div>
</template>

<script>
export default {
  name: "rgtx",
  props:['personality'],
  data(){
    return {
      // neixiang:'',
      // panduan:'',
      // qinggan:'',
      // shigan:'',
      // sikao:'',
      // waixiang:'',
      // zhijue:'',
      // zhijueb:'',
      // name:'',
      // desc:''
    }
  },
    computed: {
      data() {
          return this.personality.data||{}
      },
        neixiang() {
            return this.data.neixiang;
        },
        panduan() {
            return this.data.panduan;
        },
        qinggan() {
            return this.data.qinggan;
        },
        shigan() {
            return this.data.shigan;
        },
        sikao() {
            return this.data.sikao;
        },
        waixiang() {
            return this.data.waixiang;
        },
        zhijue() {
            return this.data.zhijue;
        },
        zhijueb() {
            return this.data.zhijueb;
        },
        name() {
            return this.personality.name;
        },
        desc() {
            return this.personality.desc;
        },

    },
  methods:{

  },
  mounted() {

    // this.getData()
  },
}
</script>
<style lang="less" scoped>
    @import './com_report.less';
</style>